<template>
  <div class="rich-editor">
    <div class="toolbar">
      <el-button-group>
        <el-button size="mini" @click="exec('bold')">加粗</el-button>
        <el-button size="mini" @click="exec('italic')">斜体</el-button>
        <el-button size="mini" @click="exec('underline')">下划线</el-button>
      </el-button-group>
      <el-button-group>
        <el-button size="mini" @click="formatBlock('H2')">标题</el-button>
        <el-button size="mini" @click="formatBlock('H3')">小标题</el-button>
        <el-button size="mini" @click="formatBlock('P')">正文</el-button>
      </el-button-group>
      <el-button-group>
        <el-button size="mini" @click="exec('insertUnorderedList')">列表</el-button>
        <el-button size="mini" @click="exec('justifyLeft')">左对齐</el-button>
        <el-button size="mini" @click="exec('justifyCenter')">居中</el-button>
      </el-button-group>
      <el-upload
        class="img-upload"
        :action="$uploadAction"
        :headers="headers"
        :show-file-list="false"
        :on-success="onUploadSuccess"
        accept="image/*"
      >
        <el-button size="mini" type="primary" icon="el-icon-picture-outline">插入图片</el-button>
      </el-upload>
      <el-button size="mini" @click="insertImageByUrl">图片链接</el-button>
    </div>
    <div
      ref="body"
      class="editor-body"
      contenteditable="true"
      @input="emitHtml"
      @paste="onPaste"
    ></div>
    <p class="hint">支持直接粘贴图片，或点击“插入图片”上传。内容将以图文混排方式展示在产品中心。</p>
  </div>
</template>

<script>
export default {
  name: "RichEditor",
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      headers: {},
      syncing: false
    };
  },
  watch: {
    value(next) {
      if (this.syncing) return;
      const body = this.$refs.body;
      if (body && body.innerHTML !== (next || "")) {
        body.innerHTML = next || "";
      }
    }
  },
  mounted() {
    const token = sessionStorage.getItem("token");
    this.headers = token ? { Authorization: "Bearer " + token } : {};
    if (this.$refs.body) {
      this.$refs.body.innerHTML = this.value || "";
    }
  },
  methods: {
    focusEditor() {
      const body = this.$refs.body;
      if (body) body.focus();
    },
    exec(command, value) {
      this.focusEditor();
      document.execCommand(command, false, value);
      this.emitHtml();
    },
    formatBlock(tag) {
      this.focusEditor();
      document.execCommand("formatBlock", false, tag);
      this.emitHtml();
    },
    unwrapResult(response) {
      if (!response) return "";
      if (typeof response === "string") return response;
      if (response.Result) return response.Result;
      if (response.result) return response.result;
      return this.$uploadResult ? this.$uploadResult(response) : "";
    },
    insertImage(url) {
      if (!url) return;
      const src = this.$img ? this.$img(url) : url;
      this.focusEditor();
      document.execCommand(
        "insertHTML",
        false,
        `<p><img src="${src}" alt="" style="max-width:100%;height:auto;border-radius:8px;margin:12px 0;" /></p>`
      );
      this.emitHtml();
    },
    onUploadSuccess(response) {
      const url = this.unwrapResult(response);
      if (!url) {
        this.$message.error("图片上传失败");
        return;
      }
      this.insertImage(url);
    },
    insertImageByUrl() {
      this.$prompt("请输入图片地址", "插入图片", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^https?:\/\/.+/,
        inputErrorMessage: "请输入有效的图片 URL"
      })
        .then(({ value }) => this.insertImage(value))
        .catch(() => {});
    },
    onPaste(e) {
      const items = (e.clipboardData && e.clipboardData.items) || [];
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.type && item.type.indexOf("image") === 0) {
          e.preventDefault();
          const file = item.getAsFile();
          if (file) this.uploadFile(file);
          return;
        }
      }
    },
    uploadFile(file) {
      const form = new FormData();
      form.append("file", file);
      const token = sessionStorage.getItem("token");
      this.$http
        .post("File/UploadingFormFile", form, {
          headers: {
            Authorization: token ? "Bearer " + token : ""
          }
        })
        .then(res => {
          const url = res.data;
          if (url) this.insertImage(url);
          else this.$message.error("图片上传失败");
        })
        .catch(() => this.$message.error("图片上传失败"));
    },
    emitHtml() {
      const html = (this.$refs.body && this.$refs.body.innerHTML) || "";
      this.syncing = true;
      this.$emit("input", html);
      this.$nextTick(() => {
        this.syncing = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.rich-editor {
  border: 1px solid #d7e6f2;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  padding: 10px 12px;
  background: #f5f9fc;
  border-bottom: 1px solid #e6eef5;
}

.img-upload {
  display: inline-block;
}

.editor-body {
  min-height: 420px;
  max-height: 640px;
  overflow: auto;
  padding: 18px 20px;
  line-height: 1.8;
  color: #17324a;
  outline: none;
}

.editor-body >>> img {
  max-width: 100%;
  height: auto;
}

.editor-body >>> h2 {
  margin: 18px 0 10px;
  font-size: 24px;
}

.editor-body >>> h3 {
  margin: 14px 0 8px;
  font-size: 18px;
}

.hint {
  margin: 0;
  padding: 8px 12px 12px;
  font-size: 12px;
  color: #7a93a8;
  background: #f8fbfe;
  border-top: 1px solid #eef3f7;
}
</style>
